import { DayTime } from "./DayTime";
import { DayTimePeriod } from "./day-time-period";

export class DatePeriod {
  from: Date;
  to: Date;

  constructor(from: Date, to: Date) {
    this.from = from;
    this.to = to;
  }

  get fromDayTime() {
    return new DayTime(
      this.from.getHours() * 3600 + this.from.getMinutes() * 60 + this.from.getSeconds()
    );
  }

  get toDayTime() {
    return new DayTime(
      this.to.getHours() * 3600 + this.to.getMinutes() * 60 + this.to.getSeconds()
    );
  }

  withDayTimePeriod(dtp: DayTimePeriod) {
    const startDate =
      dtp.from.toSeconds() < this.fromDayTime.toSeconds() ? this.to : this.from;

    return dtp.toDatePeriod(startDate);
  }
}
